import { useCallback, useEffect, useState } from "react";
import api from "../../axiosconfig";

export const REPORT_FIELDS = [
  "PhysicalSummary", "EmotionalSummary", "AcceptanceSummary", "RelationshipSummary",
  "LovingKindnessSummary", "IntellectualSummary", "GeneralSummary",
];
const EMPTY_SCORES = [null, null, null, null, null, null];

export default function useAssessmentReport() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [revision, setRevision] = useState(0);
  const reload = useCallback(() => setRevision((value) => value + 1), []);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    setPayload(null);
    api.get("/api/assessments/latest-report")
      .then(({ data }) => {
        if (!active) return;
        if (!Array.isArray(data?.report?.scores) || data.report.scores.length !== 6 ||
            !REPORT_FIELDS.every((field) => typeof data?.data?.[field] === "string")) {
          throw new Error("Incomplete assessment report");
        }
        setPayload(data);
      })
      .catch((failure) => {
        if (!active) return;
        setError(failure?.response?.status === 404
          ? "Complete an assessment section to see your report."
          : "Unable to load your assessment report. Please try again.");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [revision]);

  const scores = payload?.report?.scores || EMPTY_SCORES;
  return {
    metadata: payload?.report || null,
    analysis: payload?.data || null,
    scores,
    hasData: scores.some((score) => typeof score === "number" && score >= 1),
    loading, error, reload,
  };
}
